import React from "react";
import { Box, Button, createStyles, Grid, makeStyles, Theme, Typography } from "@material-ui/core";
import { ApplicationState } from "../store";
import { ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import { setBanner } from "../store/users/action";
import { connect } from "react-redux";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    boxBanner: {
      backgroundColor: "#fff3f3",
      border: "1px solid #da2232",
      display: "flex",
      justifyContent: "center",
      borderRadius: "8px",
      paddingBottom: "16px",
    },
    importantText: {
      fontSize: "16px",
      [theme.breakpoints.down("sm")]: {
        fontSize: "12px",
      },
    },
    button: {
      width: "250px",
      backgroundColor: "#da2232",
      color: "#ffffff",
      borderRadius: "0px",
      "&:hover": {
        cursor: "pointer",
        backgroundColor: "#9b1b25",
        color: "#ffffff",
      },
      [theme.breakpoints.down("sm")]: {
        width: "150px",
      },
    },
  })
);

interface IProps {
  setBanner: () => any;
}

type AllProps = IProps;

const ProfileBanner: React.FC<AllProps> = ({
  setBanner,
}) => {
  const classes = useStyles();

  const handleSetBannerOff = () => {
    setBanner();
  };

  return (
    <>
      <Box pt={5} pb={5} className={classes.boxBanner}>
        <Grid container spacing={3} direction="row">
          <Grid item xs={12} sm={12} md={12}>
            <Box textAlign="center" mb={2}>
              <Typography variant="h5" style={{ fontWeight: 600 }}>
                Svarīga informācija nomniekiem!
              </Typography>
              <Typography className={classes.importantText}>
                Lai saņemtu nomas pakalpojumu, jums ir jāaizpilda un jāparaksta nomas līgums. To jūs varat izdarīt šeit: <a href="/profile/pilnvaras">Pilnvarojumu lapā</a>.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <Box textAlign="right" pr={3}>
              <Button
                variant="contained"
                onClick={handleSetBannerOff}
                size="large"
                className={classes.button}
              >
                IEPAZINOS
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <br/>
      <br/>
    </>
  );
};


const mapStateToProps = ({ }: ApplicationState) => ({
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
  return {
    setBanner: () => {
      dispatch(setBanner());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileBanner);